// extracted by css-extract-rspack-plugin
export default {"container":"loading__container___DbMWY","loading":"loading__loading___fvxGb common__spin___gjmWD"};